"use client";

import { c as _c } from "react/compiler-runtime";
import type { Dispatch } from "react";
import { useCallback } from "react";
import type { AdditionalMedia, AirdropEntry, AllowlistBatchRaw, PaymentInfo } from "../types/OperationalData";
import { SubmissionStep } from "../types/Steps";
import type { TraitsData } from "../types/TraitsData";
import type { FormAction, FormState, ProfileDefaults } from "./artworkSubmissionFormState";
interface UseArtworkSubmissionFormActionsParams {
  readonly state: FormState;
  readonly dispatch: Dispatch<FormAction>;
  readonly profileDefaults?: ProfileDefaults | undefined;
  readonly shouldApplyProfileDefaults?: boolean | undefined;
}
export function useArtworkSubmissionFormActions(t0) {
  const $ = _c(49);
  const {
    state,
    dispatch,
    profileDefaults,
    shouldApplyProfileDefaults: t1
  } = t0;
  const shouldApplyProfileDefaults = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== profileDefaults || $[2] !== shouldApplyProfileDefaults) {
    t2 = () => {
      if (!shouldApplyProfileDefaults) {
        return;
      }
      dispatch({
        type: "APPLY_PROFILE_DEFAULTS",
        payload: profileDefaults ?? {}
      });
    };
    $[0] = dispatch;
    $[1] = profileDefaults;
    $[2] = shouldApplyProfileDefaults;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const applyProfileDefaults = t2;
  let t3;
  if ($[4] !== applyProfileDefaults || $[5] !== dispatch) {
    t3 = () => {
      applyProfileDefaults();
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ARTWORK
      });
    };
    $[4] = applyProfileDefaults;
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleContinueFromTerms = t3;
  let t4;
  if ($[7] !== applyProfileDefaults || $[8] !== dispatch) {
    t4 = () => {
      applyProfileDefaults();
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ADDITIONAL_INFO
      });
    };
    $[7] = applyProfileDefaults;
    $[8] = dispatch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleContinueFromArtwork = t4;
  let t5;
  if ($[10] !== dispatch) {
    t5 = () => {
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ARTWORK
      });
    };
    $[10] = dispatch;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleBackToArtwork = t5;
  let t6;
  if ($[12] !== dispatch) {
    t6 = value => {
      dispatch({
        type: "SET_AGREEMENTS",
        payload: value
      });
    };
    $[12] = dispatch;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const setAgreements = t6;
  let t7;
  if ($[14] !== dispatch) {
    t7 = (field, value_0) => {
      dispatch({
        type: "SET_TRAIT_FIELD",
        payload: {
          field,
          value: value_0
        }
      });
    };
    $[14] = dispatch;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateTraitField = t7;
  let t8;
  if ($[16] !== dispatch) {
    t8 = traitsUpdate => {
      dispatch({
        type: "SET_MULTIPLE_TRAITS",
        payload: traitsUpdate
      });
    };
    $[16] = dispatch;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const setTraits = t8;
  let t9;
  if ($[18] !== dispatch) {
    t9 = entries => {
      dispatch({
        type: "SET_AIRDROP_CONFIG",
        payload: entries
      });
    };
    $[18] = dispatch;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const setAirdropConfig = t9;
  let t10;
  if ($[20] !== dispatch) {
    t10 = paymentInfo => {
      dispatch({
        type: "SET_PAYMENT_INFO",
        payload: paymentInfo
      });
    };
    $[20] = dispatch;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const setPaymentInfo = t10;
  let t11;
  if ($[22] !== dispatch) {
    t11 = batches => {
      dispatch({
        type: "SET_ALLOWLIST_BATCHES",
        payload: batches
      });
    };
    $[22] = dispatch;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const setAllowlistBatches = t11;
  let t12;
  if ($[24] !== dispatch) {
    t12 = additionalMedia => {
      dispatch({
        type: "SET_ADDITIONAL_MEDIA",
        payload: additionalMedia
      });
    };
    $[24] = dispatch;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const setAdditionalMedia = t12;
  let t13;
  if ($[26] !== dispatch) {
    t13 = commentary => {
      dispatch({
        type: "SET_COMMENTARY",
        payload: commentary
      });
    };
    $[26] = dispatch;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const setCommentary = t13;
  let t14;
  if ($[28] !== dispatch) {
    t14 = aboutArtist => {
      dispatch({
        type: "SET_ABOUT_ARTIST",
        payload: aboutArtist
      });
    };
    $[28] = dispatch;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const setAboutArtist = t14;
  let t15;
  if ($[30] !== state) {
    t15 = () => {
      const {
        artworkUrl,
        operationalData,
        traits
      } = state;
      return {
        imageUrl: artworkUrl,
        traits: {
          ...traits,
          title: traits.title,
          description: traits.description
        },
        operationalData
      };
    };
    $[30] = state;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const getSubmissionData = t15;
  let t16;
  if ($[32] !== state) {
    t16 = () => ({
      mediaSource: state.mediaSource,
      selectedFile: state.selectedFile,
      existingMedia: state.existingMedia,
      externalUrl: state.externalMedia.url,
      externalPreviewUrl: state.externalMedia.previewUrl,
      externalProvider: state.externalMedia.provider,
      externalHash: state.externalMedia.sanitizedHash,
      externalMimeType: state.externalMedia.mimeType,
      isExternalValid: state.externalMedia.isValid
    });
    $[32] = state;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const getMediaSelection = t16;
  let t17;
  if ($[34] !== getMediaSelection || $[35] !== getSubmissionData || $[36] !== handleBackToArtwork || $[37] !== handleContinueFromArtwork || $[38] !== handleContinueFromTerms || $[39] !== setAboutArtist || $[40] !== setAdditionalMedia || $[41] !== setAgreements || $[42] !== setAirdropConfig || $[43] !== setAllowlistBatches || $[44] !== setCommentary || $[45] !== setPaymentInfo || $[46] !== setTraits || $[47] !== updateTraitField) {
    t17 = {
      getMediaSelection,
      getSubmissionData,
      handleBackToArtwork,
      handleContinueFromArtwork,
      handleContinueFromTerms,
      setAboutArtist,
      setAdditionalMedia,
      setAgreements,
      setAirdropConfig,
      setAllowlistBatches,
      setCommentary,
      setPaymentInfo,
      setTraits,
      updateTraitField
    };
    $[34] = getMediaSelection;
    $[35] = getSubmissionData;
    $[36] = handleBackToArtwork;
    $[37] = handleContinueFromArtwork;
    $[38] = handleContinueFromTerms;
    $[39] = setAboutArtist;
    $[40] = setAdditionalMedia;
    $[41] = setAgreements;
    $[42] = setAirdropConfig;
    $[43] = setAllowlistBatches;
    $[44] = setCommentary;
    $[45] = setPaymentInfo;
    $[46] = setTraits;
    $[47] = updateTraitField;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
}